export default __webpack_public_path__ + "static/media/icon-mobile-device.c7ffda9b.svg";